import type { PortalCredentials } from "./authSlice";

type PortalIdentity = {
  tenantId: string;
  loginId: string;
  customerId: string | null;
  verifiedEmails: string[];
};

export const portalIdentity = {
  read(credentials: PortalCredentials | null): PortalIdentity | null {
    if (!credentials) return null;
    try {
      const payload = credentials.accessToken.split(".")[1];
      const bytes = Uint8Array.from(atob(payload.replace(/-/g, "+").replace(/_/g, "/")), (char) =>
        char.charCodeAt(0),
      );
      const claims = JSON.parse(new TextDecoder().decode(bytes));
      if (typeof claims.tenant_id !== "string") return null;
      const emails =
        typeof claims.verified_email === "string" ? [claims.verified_email] : claims.verified_email;
      return {
        tenantId: claims.tenant_id,
        loginId: typeof claims.sub === "string" ? claims.sub : "",
        customerId: typeof claims.customer_id === "string" ? claims.customer_id : null,
        verifiedEmails: Array.isArray(emails)
          ? emails.filter((email): email is string => typeof email === "string")
          : [],
      };
    } catch {
      return null;
    }
  },

  scope(credentials: PortalCredentials | null): string | null {
    const identity = this.read(credentials);
    return identity
      ? JSON.stringify([identity.tenantId, identity.loginId, identity.customerId])
      : null;
  },

  isSameScope(a: PortalCredentials | null, b: PortalCredentials | null): boolean {
    if (a === b) return true;
    const scope = this.scope(a);
    return scope !== null && scope === this.scope(b);
  },
};
